// This prevents one tab from overwriting another tab asset context & handle cache clean up properly
(function installTabScopedStoragePatch() {
  if (typeof window === "undefined") {
    return;
  }

  const scopedKeys = new Set([
    "assetInfo",
    "cloudPermitSelectedTab",
    "selectedTab",
  ]);
  const storageProto = Object.getPrototypeOf(window.localStorage);

  if (!storageProto || storageProto.__tabScopedPatched) {
    return;
  }

  const originalGetItem = storageProto.getItem;
  const originalSetItem = storageProto.setItem;
  const originalRemoveItem = storageProto.removeItem;

  if (
    typeof originalGetItem !== "function" ||
    typeof originalSetItem !== "function" ||
    typeof originalRemoveItem !== "function"
  ) {
    return;
  }

  const toSessionKey = (key) => `tabScoped:v1:${key}`;

  const getFromScopedSession = (key) => {
    try {
      return window.sessionStorage.getItem(toSessionKey(key));
    } catch (error) {
      return null;
    }
  };

  const setToScopedSession = (key, value) => {
    try {
      window.sessionStorage.setItem(toSessionKey(key), String(value));
      return true;
    } catch (error) {
      return false;
    }
  };

  const removeFromScopedSession = (key) => {
    try {
      window.sessionStorage.removeItem(toSessionKey(key));
    } catch (error) {
      // Ignore storage quota or privacy errors to avoid breaking app flow.
    }
  };

  storageProto.getItem = function getItem(key) {
    const normalizedKey = String(key);

    if (this === window.localStorage && scopedKeys.has(normalizedKey)) {
      const scopedValue = getFromScopedSession(normalizedKey);
      if (scopedValue !== null) {
        return scopedValue;
      }

      // One time migration path for pre patch values in localStorage.
      const legacyValue = originalGetItem.call(this, normalizedKey);
      if (legacyValue !== null) {
        setToScopedSession(normalizedKey, legacyValue);
        originalRemoveItem.call(this, normalizedKey);
        return legacyValue;
      }

      return null;
    }

    return originalGetItem.call(this, key);
  };

  storageProto.setItem = function setItem(key, value) {
    const normalizedKey = String(key);

    if (this === window.localStorage && scopedKeys.has(normalizedKey)) {
      setToScopedSession(normalizedKey, value);
      // Remove any stale global value to prevent cross tab leak.
      originalRemoveItem.call(this, normalizedKey);
      return;
    }

    return originalSetItem.call(this, key, value);
  };

  storageProto.removeItem = function removeItem(key) {
    const normalizedKey = String(key);

    if (this === window.localStorage && scopedKeys.has(normalizedKey)) {
      removeFromScopedSession(normalizedKey);
      originalRemoveItem.call(this, normalizedKey);
      return;
    }

    return originalRemoveItem.call(this, key);
  };

  Object.defineProperty(storageProto, "__tabScopedPatched", {
    value: true,
    configurable: false,
    enumerable: false,
    writable: false,
  });
})();
